import { Mode } from '@ocean/types/dist/appearance'
import { common } from '@ocean/ui'
import { TypographyProps } from '@ocean/ui/dist/components/common/Typography'
import { Root, Content, Title, Info } from './ActivityLabel.styled'

const { Typography } = common

export type ActivityLabelProps = {
  title?: string
  label?: string
  mode?: Mode
  variant?: TypographyProps['variant']
  dataTest?: string
}

const ActivityLabel: React.FC<ActivityLabelProps> = props => {
  const { label, title, mode, variant = 'small', dataTest } = props

  return (
    <Root data-test={dataTest}>
      <Content>
        {title && (
          <Title mode={mode}>
            <Typography variant={variant} dataTest='ActivityLabelTitle'>
              {title}
            </Typography>
          </Title>
        )}
        {label && (
          <Info mode={mode}>
            <Typography variant='h3' dataTest='ActivityLabelLabel'>
              {label}
            </Typography>
          </Info>
        )}
      </Content>
    </Root>
  )
}

export default ActivityLabel
